import React from 'react';
import { cn } from '../../lib/utils';

export function TypingDots({ className, dotClassName, size = 'sm' }) {
  const dotSize =
    size === 'lg'
      ? 'h-2 w-2'
      : size === 'md'
      ? 'h-1.5 w-1.5'
      : 'h-[5px] w-[5px]';

  return (
    <span className={cn('inline-flex items-center gap-[3px]', className)} aria-hidden>
      <span className={cn('typing-dot', dotSize, 'rounded-full bg-zinc-400', dotClassName)} />
      <span className={cn('typing-dot typing-dot-delay-1', dotSize, 'rounded-full bg-zinc-400', dotClassName)} />
      <span className={cn('typing-dot typing-dot-delay-2', dotSize, 'rounded-full bg-zinc-400', dotClassName)} />
    </span>
  );
}

export function TypingIndicator({
  label = 'Duke shkruar...',
  senderName,
  variant = 'inline',
  className,
  dotSize = 'sm',
  avatar = null,
}) {
  if (variant === 'bubble') {
    return (
      <div className={cn('flex items-end gap-2 px-3 pb-1 animate-in fade-in duration-200', className)} role="status" aria-live="polite">
        {avatar}
        <div className="flex min-w-0 flex-col items-start">
          {senderName && (
            <div className="mb-1 px-1 text-[11px] font-semibold text-zinc-400">{senderName}</div>
          )}
          <div className="rounded-2xl rounded-bl-sm border border-zinc-200/80 bg-white px-3.5 py-2 shadow-xs flex items-center gap-1.5">
            <span className="text-xs text-zinc-500 font-medium">{label}</span>
            <TypingDots size="md" dotClassName="bg-amber-500" />
          </div>
        </div>
      </div>
    );
  }

  if (variant === 'subtitle') {
    return (
      <span
        className={cn('inline-flex min-w-0 items-center gap-1.5 truncate text-xs text-amber-600 font-semibold', className)}
        role="status"
        aria-live="polite"
      >
        <span className="truncate">{label}</span>
        <TypingDots size="sm" dotClassName="bg-amber-500" />
      </span>
    );
  }

  return (
    <span
      className={cn('inline-flex min-w-0 max-w-full items-center gap-1.5 truncate text-xs text-amber-600 font-medium', className)}
      role="status"
      aria-live="polite"
    >
      <span className="truncate">{label}</span>
      <TypingDots size={dotSize} dotClassName="bg-amber-500 shrink-0" />
    </span>
  );
}

export default TypingIndicator;
